import type { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Tabs as AntdTabs } from 'antd';
import { RESELLERS_TABS_TRANSLATED, ResellersTab } from '../enums/resellersTab';

export const ResellersTabs: FC = () => {
  const history = useHistory();
  const { resellersTab } = useParams<{
    resellersTab: ResellersTab;
  }>();

  return (
    <AntdTabs
      activeKey={resellersTab}
      items={Object.values(ResellersTab).map(tab => ({
        key: tab,
        label: RESELLERS_TABS_TRANSLATED[tab],
      }))}
      onTabClick={(selectedTab: string) => history.push(selectedTab)}
    />
  );
};
